export const isProductionEnvironment = () =>
  window?.deployment?.environment === 'production';

/**
 * Checks if user is in a environment that will affect the production db.
 */
export const isDangerousDev = () =>
  window?.deployment?.database === 'production' && !isProductionEnvironment();
export const isCloneDb = () => window?.deployment?.database === 'clone';

export const confirmInDangerousDev = <R>(callback: () => R): R => {
  if (
    isDangerousDev() &&
    !window.confirm(
      'Changes in this environment will affect the real data, are you sure you want to do this?'
    )
  )
    return null;
  return callback();
};
